import React from 'react'

import { TDocumentResponse } from '../../../common/validations/document'

import { useAPIGetContractDocumentsSuspense } from 'api/apiHooks/useAPIGetContractDocuments'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  data: TDocumentResponse
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data } = useAPIGetContractDocumentsSuspense(currentContractId)

  return children({ data })
}
